import React from "react";
import AppIcon from "./AppIcon";
import { ModalShell } from "./ui-helpers";

export default function LocalPdfPreview({ file, title = "PDF" }) {
  const [open, setOpen] = React.useState(false);
  const [objectUrl, setObjectUrl] = React.useState("");
  const isPdf = !!file && (
    file.type === "application/pdf" ||
    String(file.name || "").toLowerCase().endsWith(".pdf")
  );

  React.useEffect(() => {
    if (isPdf) return undefined;
    setOpen(false);
    return undefined;
  }, [isPdf]);

  React.useEffect(() => {
    if (!open || !isPdf) {
      setObjectUrl("");
      return undefined;
    }

    const nextUrl = URL.createObjectURL(file);
    setObjectUrl(nextUrl);
    return () => {
      URL.revokeObjectURL(nextUrl);
    };
  }, [file, isPdf, open]);

  if (!isPdf) return null;

  return (
    <>
      <button
        className="icon-btn local-pdf-preview-button"
        type="button"
        title={`Preview ${title}`}
        aria-label={`Preview ${title}`}
        onClick={() => setOpen(true)}
      >
        <AppIcon name="eye" />
      </button>
      <ModalShell
        open={open}
        title={`Preview ${title}`}
        subtitle={file.name || undefined}
        size="xl"
        className="local-pdf-preview-modal"
        onClose={() => setOpen(false)}
        actions={(
          <button className="btn btn-secondary" type="button" onClick={() => setOpen(false)}>
            Close preview
          </button>
        )}
      >
        {objectUrl ? (
          <iframe
            className="local-pdf-preview-frame"
            title={`${title} preview`}
            src={objectUrl}
          />
        ) : (
          <div className="helper-text">Preparing preview…</div>
        )}
      </ModalShell>
    </>
  );
}
